export default {
    formatCurrency: function (num) {
        return 'R$' + num.toFixed(2) + '';
    }
}